import { useState } from 'react';
import { CasRenderDateTime, CasTable } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';
import prependAllOption from 'src/compass/shared/util/prependAllOption';
import { CasUserSelect, CasYesNoSelect } from 'src/compass/application';

import ClaimDetailsDialog from '../shared/ClaimDetails/ClaimDetailsDialog';

const ACTION_TYPE_OPTIONS = prependAllOption(
  StringsToOptions([
    'Approved',
    'Approved & Verified',
    'Attached',
    'Back',
    'Callback Completed',
    'Claim Notes',
    'Dead Report',
    'Deficient',
    'Docusign Received',
    'Notice Received',
    'Rejected',
    'Resent',
    'Reviewed',
    'Sent',
    'Verified',
  ])
);

export default function ActivityLogTab({ endorsementId }: { endorsementId?: number }) {
  const [dialogRowId, setDialogRowId] = useState<number | null>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  return (
    <>
      <CasTable
        entity="Sce/Claims/Log"
        refreshBtn
        update={reloadTable}
        includeExport={false}
        columnsSortable={false}
        columns={[
          { field: 'dateCreated', label: 'When', render: CasRenderDateTime },
          { field: 'actionType', label: 'Action' },
          { field: 'activity', label: 'Details' },
          ...(endorsementId
            ? []
            : [
                {
                  field: 'insuredName',
                  render: ({ row, column }: ICasRenderCellProps) => (
                    <CasLink onClick={() => setDialogRowId(row.endorsementId)}>
                      {getCasTableCellValue({ row, column })}
                    </CasLink>
                  ),
                },
                { field: 'policyNumber', label: 'Policy#' },
                { field: 'sce' },
              ]),
          { field: 'by' },
        ]}
        filters={[
          ...(endorsementId
            ? []
            : [
                {
                  type: 'date',
                  name: 'dateCreated',
                  label: 'When',
                },
              ]),
          {
            type: 'select',
            name: 'actionType',
            label: 'Action',
            options: ACTION_TYPE_OPTIONS,
          },
          {
            type: 'component',
            name: 'userId',
            label: 'By',
            includeAllOption: true,
            component: CasUserSelect,
          },
          {
            type: 'component',
            name: 'includeCheckedInOut',
            label: 'Include Checked In/Out?',
            initialValue: false,
            component: CasYesNoSelect,
          },
        ]}
        additionalPayload={{
          endorsementId,
          specialSort: 'id desc',
        }}
      />

      {dialogRowId && (
        <ClaimDetailsDialog
          id={dialogRowId}
          onClose={() => {
            setDialogRowId(null);
            setReloadTable(new Date());
          }}
        />
      )}
    </>
  );
}
